module.exports = __webpack_public_path__ + "static/img/Guibian.deef711.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/card/Guibian.jpg
// module id = sXnf
// module chunks = 1